module.exports = __webpack_public_path__ + "static/media/10.368e325b.svg";